/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { IListCountsProps } from "./IListCountsProps";
import { ResultCount } from "./ListCounts.styles";

/**
 * Renders count for the number of currently records in list
 * in list to total number
 */
export const ListCounts = ({ loading, total }: IListCountsProps): React.ReactElement => {
  if (loading) return <ResultCount />;

  return <ResultCount>Results: {total}</ResultCount>;
};

export default ListCounts;
